import React from "react";
import Success from "../../../assets/assets/Groupsuccess.svg";
import { PropTypes } from 'prop-types';

const Modal = (props) => {
  return (
    <div className="success-modal-body">
      <div className="modal-image">
        <img src={Success} alt="icon" />
      </div>
      <h3>Migration Schedule Successful</h3>
      <p>
        Kindly check back when admin approves
      </p>
      <div className="modal-btn">
        <button onClick={() => props.click()}>continue</button>
      </div>
    </div>
  );
};

Modal.propTypes = {
  click: PropTypes.func
}

export default Modal;
